module.exports = {"430104001":"望月湖街道","430104002":"岳麓街道","430104003":"桔子洲街道","430104004":"银盆岭街道","430104005":"观沙岭街道","430104006":"望城坡街道","430104007":"西湖街道","430104008":"咸嘉湖街道","430104009":"望岳街道","430104010":"梅溪湖街道","430104011":"麓谷街道","430104012":"坪塘街道","430104013":"含浦街道","430104014":"天顶街道","430104015":"洋湖街道","430104016":"学士街道","430104017":"东方红街道","430104102":"莲花镇","430104105":"雨敞坪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430104.json
// module id = 1930
// module chunks = 0